<template>
  <div class="modal-mask" v-show="show" transition="modal" @click="hide">
    <div class="video-modal-wrapper">
      <div class="video-modal-container modal-transition-container">
        <slot name="loading"></slot>
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
// modal component styled for video playback

export default {
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  mounted: function () {
    window.addEventListener('keyup', this.keypressed)
  },
  beforeDestroy: function () {
    window.removeEventListener('keyup', this.keypressed)
  },
  methods: {
    keypressed: function (event) {
      let esc = 27
      if (event.keyCode === esc) {
        this.hide()
      }
    },
    hide: function () {
      this.$emit('hide')
    }
  }
}
</script>



// WEBPACK FOOTER //
// VideoModal.vue?76b44664